export default {
    ATENDIMENTO: 1,
    FAA: 2,
}